import script from "./vpresentstock.vue?vue&type=script&setup=true&lang=js"
export * from "./vpresentstock.vue?vue&type=script&setup=true&lang=js"

import "./vpresentstock.vue?vue&type=style&index=0&id=d5c03e04&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5c03e04"]])

export default __exports__